import React, { ReactNode } from 'react'
import { camelCase, kebabCase } from 'lodash'
import {
  IProps as ICardsWithImage,
  CardsWithImage,
} from 'marketing-site/src/mvp/library/components/CardsWithImage'
import {
  ICardsWithImageMvp as IContentfulCardsWithImage,
  IInteractiveCard,
  IInteractiveCardMini,
  IStaticCard,
  INameplateCard,
} from 'marketing-site/@types/generated/contentful'
import { CTALink } from 'marketing-site/src/mvp/library/elements/CTALink'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { transformCTAWithBackground } from 'marketing-site/src/mvp/transformers/elements/ContentfulCTALink'
import { InteractiveCard } from '../../library/elements/InteractiveCard'
import { transformInteractiveCard } from '../elements/ContentfulInteractiveCard'
import { NameplateCard } from '../../library/elements/NameplateCard'
import { transformNamePlateCard } from '../elements/ContentfulNameplateCard'
import { StaticCard } from '../../library/elements/StaticCard'
import { transformStaticCard } from '../elements/ContentfulStaticCard'
import { InteractiveCardMini } from '../../library/elements/InteractiveCardMini'
import { transformInteractiveCardMini } from '../elements/ContentfulInteractiveCardMini'

export const ContentfulCardsWithImage = (
  cardsWithImage: IContentfulCardsWithImage,
): React.ReactElement => (
  <EntryMarker entry={cardsWithImage}>
    {() => <CardsWithImage {...transformCardsWithImage(cardsWithImage)} />}
  </EntryMarker>
)

const transformCard = (
  card: IInteractiveCard | IInteractiveCardMini | IStaticCard | INameplateCard,
): ReactNode => {
  switch (card.sys.contentType.sys.id) {
    case 'interactiveCard':
      return <InteractiveCard {...transformInteractiveCard(card as IInteractiveCard)} />
    case 'interactiveCardMini':
      return <InteractiveCardMini {...transformInteractiveCardMini(card as IInteractiveCardMini)} />
    case 'nameplateCard':
      return <NameplateCard {...transformNamePlateCard(card as INameplateCard)} />
    case 'staticCard':
      return <StaticCard {...transformStaticCard(card as IStaticCard)} />
  }
}

export function transformCardsWithImage({ fields }: IContentfulCardsWithImage): ICardsWithImage {
  return {
    ...fields,
    cta: fields.cta && <CTALink {...transformCTAWithBackground(fields.cta)} />,
    cards: fields.cards.map((card) => transformCard(card)),
    backgroundColor:
      fields.backgroundColor &&
      (camelCase(fields.backgroundColor) as ICardsWithImage['backgroundColor']),
    bodyAlignment:
      fields.bodyAlignment && (kebabCase(fields.bodyAlignment) as ICardsWithImage['bodyAlignment']),
  }
}
